import Breakdown from "./Breakdown";

const sizeOrder = ["Adult S", "Adult M", "Adult L", "Adult XL"];

export default function ShirtSizeTable({ campers }) {
  const counts = {};
  (campers || []).forEach((c) => {
    counts[c.shirtSize] = (counts[c.shirtSize] || 0) + 1;
  });

  const rank = (size) =>
    sizeOrder.includes(size) ? sizeOrder.indexOf(size) : sizeOrder.length;
  const rows = Object.entries(counts).sort(
    ([a], [b]) => rank(a) - rank(b) || a.localeCompare(b)
  );

  return <Breakdown title="Shirt sizes" rows={rows} />;
}
